import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { Location, CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth/auth.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { interval, Subscription } from 'rxjs';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { XdsButtonComponent, XdsIconButtonComponent } from '../../../../shared/ui';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.css'],
    imports: [CommonModule, RouterModule, TranslateModule, XdsButtonComponent, XdsIconButtonComponent]
})
export class ForbiddenComponent implements OnInit, OnDestroy {
  attemptedRoute: string = '';
  redirectCountdown: number = 10;
  countdownSubscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private authService: AuthService,
    private translate: TranslateService,
    private toastr: ToastrService,
    public themeService: ThemeService
  ) {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  getThemeIconClass(): string {
    const mode = this.themeService.getThemeIcon();
    if (mode === 'brightness_auto') return 'fa-circle-half-stroke';
    if (mode === 'light_mode') return 'fa-sun';
    return 'fa-moon';
  }

  ngOnInit(): void {
    // Capture the attempted route from query params or state
    this.route.queryParams.subscribe((params) => {
      this.attemptedRoute = params['attemptedUrl'] || this.location.path();
    });

    // Optional: Auto-redirect after 10 seconds
    this.startAutoRedirect();

    // Log the access attempt for security monitoring
    this.logAccessAttempt();
  }

  ngOnDestroy(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

  private startAutoRedirect(): void {
    // Uncomment to enable auto-redirect
    /*
    this.countdownSubscription = interval(1000).subscribe(() => {
      this.redirectCountdown--;
      if (this.redirectCountdown <= 0) {
        this.goToDashboard();
      }
    });
    */
  }

  private logAccessAttempt(): void {
    // Log unauthorized access attempt
    console.warn('Unauthorized access attempt:', {
      route: this.attemptedRoute,
      timestamp: new Date().toISOString(),
      user: this.authService.Email,
    });
  }

  goBack(): void {
    // Navigate back in browser history
    this.location.back();
  }

  goToDashboard(): void {
    // Navigate to appropriate dashboard based on user role
    const redirectUrl = this.authService.getRedirectUrlAfterLogin();
    this.router.navigate([redirectUrl]);
  }

  contactSupport(): void {
    // Show support contact information
    this.toastr.info(
      this.translate.instant('CONTACT_SUPPORT_MESSAGE'),
      this.translate.instant('SUPPORT'),
      {
        timeOut: 10000,
        enableHtml: true,
        closeButton: true,
      }
    );

    // Optional: Open email client
    window.location.href =
      'mailto:support@fixplaner.de?subject=Access%20Denied%20-%20403%20Error';
  }
}
